(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('SSEditarEstatusModalService', SSEditarEstatusModalService);

    SSEditarEstatusModalService.$inject = ['$uibModal'];

    function SSEditarEstatusModalService ($uibModal) {
        var service = {
        	openCentral: openCentral,
        	openComite: openComite
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function openCentral (idProyecto) {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-proyecto/ss-editar-estatus-central-dialog.html',
                controller: 'SSEditarEstatusController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            fechaMovimiento: null,
                            estatusMovimiento: null,
                            observaciones: null,
                            altaReg: null,
                            bajaReg: null,
                            ultActReg: null,
                            activo: null,
                            usuarioUltAct: null,
                            id: null,
                            proyecto: idProyecto
                        };
                    },
                     proyecto: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    	 return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                     }],
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function openComite (idProyecto) {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-proyecto/ss-editar-estatus-comite-dialog.html',
                controller: 'SSEditarEstatusController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            fechaMovimiento: null,
                            estatusMovimiento: null,
                            observaciones: null,
                            altaReg: null,
                            bajaReg: null,
                            ultActReg: null,
                            activo: null,
                            usuarioUltAct: null,
                            id: null,
                            proyecto: idProyecto
                        };
                    },
                    proyecto: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                   	 return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                    }],
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
    }
})();
